export interface FaqLink {
    label: string;
    url: string;
}
export type FaqInlineLink = { text: string; url: string };
export type FaqParagraph = string | (string | FaqInlineLink)[];

export interface FaqItem {
    id: string;
    question: string;
    answer: FaqParagraph[];
    link?: FaqLink;
}

export const FAQ: FaqItem[] = [
    {
        id: 'results',
        question: 'Когда будут оглашены результаты выборов?',
        answer: [
            'Результаты объявят в аудитории 119/1 сразу после окончания ' +
                'голосования. Позже они появятся на сайте.',
        ],
    },
    {
        id: 'offline',
        question: 'Будет ли очное оглашение результатов выборов?',
        answer: [
            'Да, результаты объявят в аудитории Студенческого совета ' +
                '(119/1) сразу после окончания голосования.',
        ],
    },
    {
        id: 'stats',
        question: 'Где можно посмотреть статистику голосования?',
        answer: [
            'За ходом голосования можно следить в прямом эфире ' +
                'в аудитории Студенческого совета (119/1).',
        ],
    },
    {
        id: 'problem',
        question: 'Я столкнулся с проблемой, кому писать?',
        answer: [
            [
                'Если вы столкнулись с проблемой в работе системы ' +
                    'online-выборов, мы постараемся оперативно её решить! ' +
                    'Просто напишите в ',
                { text: 'VK', url: 'https://vk.com/vladhasnoid' },
                '.',
            ],
        ],
    },
    {
        id: 'interim-results',
        question: 'Можно ли узнать промежуточные результаты?',
        answer: [
            'Нет. Сколько голосов получил каждый кандидат, объявят ' +
                'только после окончания голосования.',
        ],
    },
];

export default FAQ;
